import ViewOriginalEmailHtmlMenuItem from './view_original_email_html_menu_item';

export default ViewOriginalEmailHtmlMenuItem;
